export const REPORTS_REFERRAL_PROGRAM_OPTIONS = {
  SCOPE: 'referral_program',
  TITLE: 'Referral program report',
  SOURCE_NAME: 'referral_program',
  DEFAULT_PAGE_SIZE: 100,
  PAGE_SIZE: [50, 100, 250, 500, 1000],
  MAX_PAGE_SIZE: 5000,
};
